import styled from 'styled-components';
import karLogoBackground from '../../assets/external/kar-global-logo-background.svg';

export const StyledOktaRedirectWrapper = styled.div`
  background: url(${karLogoBackground}) no-repeat;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  position: absolute;

  @media @bp-tablets {
    padding: 18px;
    background-image: none;
    align-items: initial;
    justify-content: initial;

    .form-wrapper {
      width: 100%;
    }
  }
`;

export default {};
